export enum OrigemTypeEnum {
  SEMORIGEM = 0,
  CRM = 1,
  B2B = 2,
  FORCAVENDAS = 3,
  FORCAVENDASTEXTIL = 4,
  LANDINGPAGEALPHABETO = 5,
  RDSTATION = 6,
}
